
Librarian.CreateCategoryWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["addCategory"],

    options: {
        id: "createCatWindow",
        width: 360,
        height: 230,
        url: null,
        parentCatId: 0,
        params: null
    },

    onComplete: null,

    initialize: function(options) {
        this.setOptions(options);

        this.onComplete = options.onComplete;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("category_create");

        // Set the content location
        this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/createcategory.html";

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        var itemEl = this.getElement("createButton");
        if (itemEl)
            itemEl.addOnClick(this.addCategory);

        itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("catForm");
        if (itemEl) {
            // Get the "name" element in this form
            itemEl = itemEl.getElement("[name=name]");
            if (itemEl) {
                // Focus the name box so that it's convenient for the user
                if (itemEl.isVisible())
                    itemEl.focus();
                itemEl.onkeydown = function(e) {
                    var evt = new Event(e);
                    if (evt.keyCode == 13) {
                        evt.stop();
                        this.addCategory();
                    }
                }.bind(this);
            }
        }
    },

    addCategory: function() {
        var catFormEl = this.getElement("catForm");
        if (!catFormEl)
            return;

        if (!catFormEl.name.value) {
            Librarian.Utils.error(Librarian.Lang.getString("category_namerequired"));
            return;
        }

        var url = this.options.url +
                      "&pcid=" + this.options.parentCatId +
                      "&name=" + encodeURIComponent(catFormEl.name.value) +
                      "&descr=" + encodeURIComponent(catFormEl.description.value);

        if ((typeof this.options.params == "object") && (this.options.params != null)) {
            for (var key in this.options.params) {
                if (!this.options.params.hasOwnProperty(key))
                    continue;

                url += '&' + key + '=' + this.options.params[key];
            }
        }

        new Librarian.Request({
            url: url,
            onSuccess: function() {
                if (typeof this.onComplete == "function")
                    this.onComplete();
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        }).send();

        this.close();
    }
});